import { useNavigate, Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useApp } from "@/store/useApp";
import { TopNav } from "@/components/TopNav";
import { homeRouteFor, isStaffRole } from "@/lib/types";

export function AppLayout() {
  const navigate = useNavigate();
  const { account, loadDeliveryUnits } = useApp();

  useEffect(() => {
    if (!account) {
      navigate("/login", { replace: true });
    } else if (isStaffRole(account.role)) {
      navigate(homeRouteFor(account), { replace: true });
    } else if (!account.profile && account.accountKind !== "UNIDADE" && window.location.pathname !== "/onboarding") {
      // Conta de unidade opera sob o titular e nunca preenche ficha comercial própria.
      navigate("/onboarding", { replace: true });
    }
  }, [account, navigate]);

  // Carrega as unidades de compra do cliente uma vez ao entrar na área do cliente. O store auto-seleciona
  // quando há uma única unidade; com várias, o seletor no topo pede a escolha antes do pedido.
  useEffect(() => {
    if (account && account.role === "CLIENT") void loadDeliveryUnits();
  }, [account, loadDeliveryUnits]);

  if (!account || isStaffRole(account.role)) return null;

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <TopNav />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
